<template>
      <div id="plan-credits">
            <section class="section plan-credits-hero animate__animated animate__fadeIn">
                  <BackButton link="/rewards" />
                  <div class="grid-container max">
                        <div class="plan-credits-grid">
                              <div class="plan-credits-left">
                                    <h1>Credits<br />by plan</h1>
                                    <p class="plan-credits-desc">Here&rsquo;s a breakdown of how many credits you can accumulate per plan and according to your coverage.</p>
                                    <div class="plan-credits-card">
                                          <h5>Easy ways to save with your plan:</h5>
                                          <ul>
                                                <li>Use in-network providers</li>
                                                <li>Use the Find Care tool to compare providers</li>
                                                <li>Take advantage of preventive care covered at 100%</li>
                                                <li>Earn Sharecare well-being incentive credits</li>
                                                <li>Explore Special Offers &amp; Discounts on your portal</li>
                                                <li>Use Sydney Health to manage your care</li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="plan-credits-right">
                                    <div class="plan-credits-tabs">
                                          <button v-for="tier in tiers" :key="tier.key" type="button" class="plan-credits-tab" :class="{ active: activeTier === tier.key }" @click="activeTier = tier.key">{{ tier.label }}</button>
                                    </div>
                                    <transition name="table-anim" enter-active-class="animate__animated animate__fadeIn animate__faster" leave-active-class="animate__animated animate__fadeOut animate__faster" mode="out-in">
                                          <div class="plan-credits-cards" :key="activeTier">
                                                <div class="plan-credits-plan" v-for="plan in creditsByTier[activeTier]" :key="plan.label" :class="{ primary: plan.key == 'hmo' }">
                                                      <p class="plan-credits-plan-label">Plan</p>
                                                      <h3>{{ plan.label }}</h3>
                                                      <div class="plan-credits-rows">
                                                            <div class="plan-credits-row">
                                                                  <span>Credits contributed by SHBP</span>
                                                                  <span>{{ plan.contributed }}</span>
                                                            </div>
                                                            <div class="plan-credits-row">
                                                                  <span>Credits you can earn</span>
                                                                  <span>{{ plan.earn }}</span>
                                                            </div>
                                                            <div class="plan-credits-row total">
                                                                  <span>Total possible credits</span>
                                                                  <span>{{ plan.total }}</span>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </transition>
                              </div>
                        </div>
                        <p class="plan-credits-footnote">Unused credits will roll over to the 2027 plan year, regardless of which SHBP Commercial (active non-MA) Plan Option you choose.</p>
                  </div>
            </section>
            <div class="plan-credits-btn-wrap">
                  <router-link to="/benefits" class="plan-credits-btn"><span>Next</span></router-link>
            </div>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"

      const creditsByTier = {
            "You": [
                  { key: "hmo", label: "HMO", contributed: 0, earn: 480, total: 480 },
                  { key: "gold", label: "HRA Gold", contributed: 400, earn: 480, total: 880 },
                  { key: "silver", label: "HRA Silver", contributed: 200, earn: 480, total: 680 },
                  { key: "bronze", label: "HRA Bronze", contributed: 100, earn: 480, total: 580 }
            ],
            "You-Spouse": [
                  { key: "hmo", label: "HMO", contributed: 0, earn: 960, total: 960 },
                  { key: "gold", label: "HRA Gold", contributed: 600, earn: 960, total: "1,560" },
                  { key: "silver", label: "HRA Silver", contributed: 300, earn: 960, total: "1,260" },
                  { key: "bronze", label: "HRA Bronze", contributed: 150, earn: 960, total: "1,110" }
            ],
            "You-Child(ren)": [
                  { key: "hmo", label: "HMO", contributed: 0, earn: 480, total: 480 },
                  { key: "gold", label: "HRA Gold", contributed: 600, earn: 480, total: "1,080" },
                  { key: "silver", label: "HRA Silver", contributed: 300, earn: 480, total: 780 },
                  { key: "bronze", label: "HRA Bronze", contributed: 150, earn: 480, total: 630 }
            ],
            "You-Family": [
                  { key: "hmo", label: "HMO", contributed: 0, earn: 960, total: 960 },
                  { key: "gold", label: "HRA Gold", contributed: 800, earn: 960, total: "1,760" },
                  { key: "silver", label: "HRA Silver", contributed: 400, earn: 960, total: "1,360" },
                  { key: "bronze", label: "HRA Bronze", contributed: 200, earn: 960, total: "1,160" }
            ]
      }

      export default {
            name: "SHBPPlanCredits",
            data() {
                  return {
                        creditsByTier,
                        activeTier: (!this.$store.state.coverage || this.$store.state.coverage == "") ? "You" : this.$store.state.coverage,
                        tiers: [
                              { key: "You", label: "You" },
                              { key: "You-Spouse", label: "You + Spouse" },
                              { key: "You-Child(ren)", label: "You + Child(ren)" },
                              { key: "You-Family", label: "You + Family" }
                        ]
                  }
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            }
      }
</script>

<style lang="scss">
#plan-credits {
      .plan-credits-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .plan-credits-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .plan-credits-left {
                  flex: 1 1 400px;
                  max-width: 460px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 24px;
                  }

                  .plan-credits-desc {
                        color: #12130f;
                        font-size: 1.125rem;
                        font-weight: 600;
                        line-height: 1.5;
                        margin-bottom: 0;
                  }
            }

            .plan-credits-card {
                  background-color: #F4F5F7;
                  padding: 32px;
                  margin-top: 32px;

                  h5 {
                        color: #1355E9;
                        font-weight: 700;
                        font-size: 1.125rem;
                        margin-bottom: 16px;
                  }

                  ul {
                        margin: 0;
                        padding: 0 0 0 1.125rem;
                  }

                  li {
                        color: #3F3A4E;
                        font-size: 0.9375rem;
                        line-height: 2;
                  }
            }

            .plan-credits-right {
                  flex: 2 1 640px;
                  max-width: 820px;
            }

            .plan-credits-tabs {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 32px;
                  margin-bottom: 24px;
                  border-bottom: solid 1px #d8dce0;
            }

            .plan-credits-tab {
                  background: none;
                  border: none;
                  padding: 0 0 16px 0;
                  font-size: 0.8125rem;
                  font-weight: 700;
                  text-transform: uppercase;
                  letter-spacing: 0.02em;
                  color: #b2b2b2;
                  border-bottom: solid 2px transparent;
                  margin-bottom: -1px;
                  cursor: pointer;

                  &.active {
                        color: #012E58;
                        border-bottom-color: #012E58;
                  }
            }

            .plan-credits-cards {
                  display: grid;
                  grid-template-columns: repeat(2, 1fr);
                  gap: 24px;
            }

            .plan-credits-plan {
                  background-color: #44B8F3;
                  color: #ffffff;
                  padding: 32px;
                  min-height: 260px;
                  display: flex;
                  flex-direction: column;

                  &.primary {
                        background-color: #1355E9;
                  }

                  .plan-credits-plan-label {
                        color: rgba(255, 255, 255, 0.8);
                        font-size: 0.75rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.04em;
                        margin-bottom: 0 !important;
                  }

                  h3 {
                        color: #ffffff;
                        font-size: 1.75rem;
                        font-weight: 700;
                        margin-bottom: 0;
                  }

                  .plan-credits-rows {
                        margin-top: auto;
                        padding-top: 32px;
                  }

                  .plan-credits-row {
                        display: flex;
                        justify-content: space-between;
                        gap: 12px;
                        font-size: 0.9375rem;
                        color: rgba(255, 255, 255, 0.9);
                        padding: 6px 0;

                        &.total {
                              font-weight: 700;
                              color: #ffffff;
                        }
                  }
            }

            .plan-credits-footnote {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 0;
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .plan-credits-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .plan-credits-left {
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .plan-credits-right {
                        max-width: 100%;
                  }

                  .plan-credits-tabs {
                        gap: 16px;
                        overflow-x: auto;
                        white-space: nowrap;
                        flex-wrap: nowrap;
                  }

                  .plan-credits-cards {
                        grid-template-columns: 1fr;
                  }
            }
      }

      .plan-credits-btn-wrap {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background-color: #ffffff;
            box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
            padding: 20px 0;
            text-align: center;
      }

      .plan-credits-btn {
            display: block;
            background-color: #1355E9;
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 1rem;
            padding: 18px 0;
            width: 100%;
            max-width: 330px;
            text-align: center;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            margin: 0 auto;

            &:hover {
                  background-color: #44B8F3;
            }
      }
}
</style>
